<template>
  <div>
    <b-card>
       <b-row class="create_team">
        <b-col cols="8" class="text-left">
          <h4>Local Time </h4>
        </b-col>
        <b-col md="4">
          <c-switch type="3d" variant="success" :checked="local_time" @change="changeTimeSettings($event)" />
        </b-col>
      </b-row>
    </b-card>
  </div>  
</template>


<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import router from '../../router'
import cSwitch from '@/components/Switch'

export default {
  props: ['local_time'],
  computed: {
    ...mapGetters(['idToken'])
  },
  components: {
    'c-switch': cSwitch
  },
  methods: {
    changeTimeSettings: function (event) {
      this.local_time = event
      this.switchTimeSettings()
    },
    switchTimeSettings () {
      let payload = {
        switchValue: this.local_time
      }
      Vue.axios.post('/admin/accounts/time_settings', payload, {
        headers: {
          Authorization: `Bearer ${this.idToken}`,
          'Cache-Control': 'no-cache, no-store',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      })
        .then(res => {
          Vue.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' })
          this.$store.commit('setLocalTime', this.local_time)
          if (!res.data.error) {
            router.go()
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
          console.log(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.switch.switch-3d {
  float: right;
}
.card {
  background: #ebeff3;
  border-radius: 10px;

  .bar {
    width: 100%;
    height: 10px;
    border-radius: 10px 10px 0 0;
  }

  .card-header {
    border-radius: 10px 10px 0 0;
    background-color: #e7e7e7;
    padding: 1rem;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/settings/localTime.vue